import React from 'react';
export function ShopByCategory() {
  const categories = [{
    title: 'Tops',
    image: 'https://cdn.magicpatterns.com/uploads/fBYnfA6aKseAyvyhDAyTcG/IMG_9834.webp'
  }, {
    title: 'Sets',
    image: 'https://cdn.magicpatterns.com/uploads/4vyZmFpdVdjYepeR3hDUH4/IMG_0166.webp'
  }, {
    title: 'Bottoms',
    image: 'https://cdn.magicpatterns.com/uploads/7GStzcnk5vw55ngtdrAHRr/IMG_9832.webp'
  }, {
    title: 'Accessories',
    image: 'https://cdn.magicpatterns.com/uploads/71P6ewbvSyG3Q6YSofSt4k/IMG_9931.webp'
  }];
  return <section className="py-16 md:py-24 px-6" data-id="element-153">
      <div className="max-w-7xl mx-auto" data-id="element-154">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-155">
          {categories.map(category => <a key={category.title} href="https://shop.purepulsepilates.com" className="group relative aspect-[3/4] overflow-hidden" data-id="element-156">
              <img src={category.image} alt={category.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-157" />
              <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 via-espresso/30 to-espresso/10 group-hover:from-espresso/80 group-hover:via-espresso/40 transition-colors duration-300" data-id="element-158" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-159">
                <h3 className="font-serif font-light text-2xl md:text-3xl text-cream mb-2" data-id="element-160">
                  {category.title}
                </h3>
                <span className="text-cream text-sm uppercase tracking-widest border-b border-rust pb-1" data-id="element-161">
                  SHOP NOW
                </span>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}